import React, { useState, useEffect} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BntMoreSupervisor from '../PopUps/BntMoreSupervisor'
import SingleSupervisor from '../Button/ButtonCard/SingleSupervisor';
import RedundantSupervisor from '../Button/ButtonCard/RedundantSupervisor';
import './Card.css';
import { Box, Typography } from '@mui/material';


/**
 * ComputerSupervisor component renders a card with information about the Computer Supervisor.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleNominalSupervisor - The callback function to call when the nominal supervisor button is clicked.
 * @param {Function} props.handleRedundantSupervisor - The callback function to call when the redundant supervisor button is clicked.
 */
const ComputerSupervisor = ({
  /**
   * The callback function to call when the nominal supervisor button is clicked.
   */
  handleNominalSupervisor, module, reset,
  /**
   * The callback function to call when the redundant supervisor button is clicked.
   */
  handleRedundantSupervisor
}) => {
  const [open, setOpen] = useState(false);

  /**
   * Handles the opening of the more info popup.
   */
  const handleClickOpen = () => {
    setOpen(true);
  };

  const [selected, setSelected] = useState(null);
  const handleSelectBase = () => {
    setSelected('base');
    handleNominalSupervisor(module);
  };

  const handleSelectRedundant = () => {
    setSelected('redundant');
    handleRedundantSupervisor(module);
  };

  useEffect(() => {
    setSelected(null);
  }, [reset]);

  return (
    <Card
      variant="outlined"
      sx={{
        /**
         * Custom styles for the card
         */
        width: '430px',
        height: '220px',
        
        border: 'none',
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
      }}
    >
      <CardContent>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontFamily: 'Open Sans',
              m: 0,

              fontWeight: 'bold',
            }}
          >
            Computer Supervisor
          </Typography>

          <BntMoreSupervisor
            /**
             * The more info button
             */
            sx={{ marginLeft: '50%' }}
            size="small"
            onClick={handleClickOpen}
            variant={selected === 'base' ? 'contained' : 'outlined'}
            selected={selected === 'base'}
          >
          </BntMoreSupervisor>                            </Box>

        <div>
          <div
            style={{
              /**
               * Custom styles for the button container
               */
              marginBottom: '1%',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <SingleSupervisor
              /**
               * The nominal supervisor button
               */
              selected={selected === 'base'}
              variant={selected === 'base' ? 'contained' : 'outlined'}
              onClick={() => handleSelectBase(module)}
            />
          </div>
          <div
            style={{
              /**
               * Custom styles for the button container
               */
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <RedundantSupervisor
              /**
               * The redundant supervisor button
               */
              variant={selected === 'redundant' ? 'contained' : 'outlined'}
              selected={selected === 'redundant'}
              onClick={() => handleSelectRedundant(module)}
            />
          </div>
        </div>
        <p
          style={{
            /**
             * Custom styles for the paragraph
             */
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '12px',
            marginRight: '16%'
          }}
        >
A Supervisor Module for satellite avionics in a compact 
ADHA-compliant 3U form factor.         </p>
        <div
          style={{
            /**
             * Custom styles for the more info button container
             */
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >

        </div>
      </CardContent>
    </Card>
  );
};

/**
 * Exports the ComputerSupervisor component as the default export.
 */
export default ComputerSupervisor;
